import { Container } from "@pixi/react";
import React from "react";
import { useSelector } from "react-redux";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { PixiSettings } from "../../../../pixiSettings";
import { usePrimaryUIToolbarDimensionsV2 } from "../../../../Hooks/usePrimaryUIToolbarDimensionsV2";
import ButtonPlay from "../Buttons/ButtonPlay";
import ButtonHoldAndWinPlay from "../Buttons/ButtonHoldAndWinPlay";
import ButtonAutoplay from "../Buttons/ButtonAutoplay";
import ButtonBetSelect from "../Buttons/ButtonBetSelect";
import BalanceDisplay from "../Displays/BalanceDisplay";
import BetDisplay from "../Displays/BetDisplay";
import WinDisplay from "../Displays/WinDisplay";
import FreeRoundsWinDisplay from "../Displays/FreeRoundsWinDisplay";

import ButtonMenu from "../Buttons/ButtonMenu";
import ButtonSound from "../Buttons/ButtonSound";
import { selectHoldAndWinActive } from "../../../../State/selectors";
import RespinsDisplay from "../Displays/RespinsDisplay";
import { FEATURES_CONFIG } from "../../../../featuresConfig";
import { USER_INTERFACE_BUTTON_CONFIG } from "../../../../textureConfigs";



const ToolbarBottom = () => {
  const { dimensions, device, orientation, getResponsiveConfig } = useDimensions();

  // Get toolbar dimensions
  const toolbar = usePrimaryUIToolbarDimensionsV2();

  // Check if HoldAndWin feature is active
  const holdAndWinActive = useSelector(selectHoldAndWinActive);

  const isMobilePortrait =
    device === PixiSettings.DEVICE.MOBILE &&
    orientation === PixiSettings.ORIENTATION.PORTRAIT;

  // Button config for positioning Menu/Sound on the left side
  const buttonConfig = React.useMemo(
    () => getResponsiveConfig(USER_INTERFACE_BUTTON_CONFIG, true),
    [getResponsiveConfig],
  );

  const isDesktop = device === PixiSettings.DEVICE.DESKTOP;

  // Desktop-only: both buttons on the left side
  const menuPositionDesktop = React.useMemo(() => ({
    x: buttonConfig.width * 0.8,
    y: toolbar.height / 2,
  }), [buttonConfig.width, toolbar.height]);

  const soundPositionDesktop = React.useMemo(() => ({
    x: buttonConfig.width * 0.8 + buttonConfig.width * 1.1,
    y: toolbar.height / 2,
  }), [buttonConfig.width, toolbar.height]);

  return (
    <Container
      name="secondary_toolbar_bottom"
      x={(dimensions.width - toolbar.width) / 2}
      y={
        isMobilePortrait
          ? dimensions.height - toolbar.height * 2 - 8
          : dimensions.height - toolbar.height
      }
      zIndex={10}
    >
      {/* Background is rendered by ToolbarBackgrounds (behind game layer) */}

      <BalanceDisplay toolbar={toolbar} />
      <BetDisplay toolbar={toolbar} />
      <ButtonAutoplay toolbar={toolbar} />

      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && holdAndWinActive ? (
        <>
          <RespinsDisplay toolbar={toolbar} />
          <ButtonHoldAndWinPlay toolbar={toolbar} />
        </>
      ) : (
        <ButtonPlay toolbar={toolbar} />
      )}
      <ButtonBetSelect toolbar={toolbar} />
      <WinDisplay toolbar={toolbar} />
      {FEATURES_CONFIG.FREE_ROUNDS.ENABLED && <FreeRoundsWinDisplay toolbar={toolbar} />}

      {/* Desktop: Menu + Sound both on left side */}
      {isDesktop && (
        <>
          <ButtonMenu toolbar={toolbar} position={menuPositionDesktop} />
          <ButtonSound toolbar={toolbar} position={soundPositionDesktop} />
        </>
      )}

      {/* Mobile landscape / Tablet: Sound left, Menu right (internal positioning) */}
      {!isMobilePortrait && !isDesktop && (
        <>
          <ButtonSound toolbar={toolbar} />
          <ButtonMenu toolbar={toolbar} />
        </>
      )}
    </Container>
  );
};

export default ToolbarBottom;
